<template>
        <div class="content-area__heading">
            <top-nav>
                <div slot="title">
                    <h2>Comissões</h2>
                </div>
                <div>
                    <i-input clearable suffix="ios-search" v-model="search" ></i-input>
                </div>
            </top-nav>
            <vs-row class="flex justify-between vx-card bg-transparent shadow-none rounded-none">
                <div class="w-1/2 vs-table-text">
                    <th>
                        {{columns[0].title}}
                        <span class="ivu-table-sort">
                            <i @click="ordenar(0,'desc')" class="ivu-icon ivu-icon-md-arrow-dropup" :class="columns[0].on?columns[0].order=='desc'?'on':'':''">
                            </i>
                            <i @click="ordenar(0,'asc')" class="ivu-icon ivu-icon-md-arrow-dropdown" :class="columns[0].on?columns[0].order=='asc'?'on':'':''">
                            </i>
                        </span>
                    </th>
                </div>
                <div class="flex w-1/2">
                    <div class="w-4/5 flex justify-between">
                            <div class="vs-table-text" v-for="(item,key) in columns.slice(1, columns.length)" v-bind:key="item.key">
                                <th>
                                    {{item.title}}
                                    <span class="ivu-table-sort">
                                        <i @click="ordenar(key + 1,'desc')" class="ivu-icon ivu-icon-md-arrow-dropup" :class="item.on?item.order=='desc'?'on':'':''">
                                        </i>
                                        <i @click="ordenar(key + 1,'asc')" class="ivu-icon ivu-icon-md-arrow-dropdown" :class="item.on?item.order=='asc'?'on':'':''">
                                        </i>
                                    </span>
                                </th>
                            </div>
                    </div>
                </div>
            </vs-row>
            <vx-card v-for="(item,key) in geral" v-bind:key="key" :title="item.nome" collapse-action
                    :refresh-content-action="item.show_refresh"
                    :columns="[item.valor_anterior,item.valor_atual]"
                    :download-card-action="item.show_download" :close="true"
                    v-on:download="function(){
                        item.download = true
                        $nextTick(() => {
                            item.download = false
                        })
                    }"
                    v-on:refresh="function(){
                        item.refresh = true
                        $nextTick(() => {
                            item.refresh = false
                        })
                    }"
                    v-on:toggle="function(close) {
                        close == false ? item.loading = true : 0
                        close == false ? item.show_refresh = true : item.show_refresh = false
                        close == false ? 0 : item.show_download = false,
                        item.close = true
                        $nextTick(() => {
                            item.close = false
                        })}
                    ">
                <div>
                    <tabela-revendedores v-if="item.loading" :row="item.comissoes" :refresh="item.refresh" :close="item.close" :download="item.download" v-on:download="(status) => item.show_download = status"></tabela-revendedores>
                </div>
            </vx-card>
            <vxCard v-for="(item,key) in listar_dados" v-bind:key="key+1" :title="item.nome" collapse-action
                    :refresh-content-action="item.show_refresh"
                    :columns="[item.valor_anterior,item.valor_atual]"
                    :download-card-action="item.show_download" :close="true"
                    v-on:download="function(){
                        item.download = true
                        $nextTick(() => {
                            item.download = false
                        })
                    }"
                    v-on:refresh="function(){
                        item.refresh = true
                        $nextTick(() => {
                            item.refresh = false
                        })
                    }"
                    v-on:toggle="function(close) {
                        close == false ? item.loading = true : 0
                        close == false ? item.show_refresh = true : item.show_refresh = false
                        close == false ? 0 : item.show_download = false,
                        item.close = true
                        $nextTick(() => {
                            item.close = false
                        })}
                    ">
                <div>
                    <tabela-revendedores v-if="item.loading" :row="item.comissoes" :refresh="item.refresh" :close="item.close" :download="item.download" v-on:download="(status) => item.show_download = status"></tabela-revendedores>
                </div>
            </vxCard>
        </div>
</template>

<script>
    import TabelaRevendedores from "./components/TabelaRevendedores.vue";
    import accounting from "accounting";
    import _ from 'lodash'
    import { revendaApi } from "@/api/axios";

    export default {
        components: {
            TabelaRevendedores,
            TableCvs: () => import("../../components/table-csv/TableCsv"),
            TopNav: () => import("../../components/nav-bar/top-nav"),
            vxCard: () => import('../../components/vx-card/VxCard')
        },
        data() {
            return {
                key: 0,
                columns: [
                    {
                        title: "Revendedor",
                        key: "nome",
                        order:'asc',
                        on:false
                    },
                    {
                        title: "Mês Anterior",
                        key: "mes_anterior",
                        order:'asc',
                        on:false
                    },
                    {
                        title: "Mês Atual",
                        key: "mes_atual",
                        order:'asc',
                        on:false
                    }
                ],
                dados: [],
                geral: [], // primeiro item dos dados separado dos demais para não entrar na ordenação
                pagination:{
                    page: 1,
                    end_page: false,
                },
                search: ''
            };
        },
        computed: {
            listar_dados() {
                // ordena os dados da tabela conforme os indice selecionado nas colunas.
                // inicialmente é pelo indice 0 que coresponde ao nome dos dados
                var dados = this.dados
                dados = _.orderBy(dados, [this.columns[this.key].key],[this.columns[this.key].order])
                return dados
            },
        },
        methods: {
            /**
             * Faz a consulta dos revendedores do sistema, traz resultado geral
             */
            async getComissoesGeral() {
                this.$Spin.show()
                try {
                    const URI = `comissoes/all/porVendedor`
                    const {data} = await revendaApi.get(URI,{params: {page:this.pagination.page,type:0}})
                    this.geral = data.map(revendedor => ({
                        nome: revendedor.nome,
                        mes_anterior: parseFloat(revendedor.mes_anterior),
                        mes_anterior_taxas: parseFloat(revendedor.mes_anterior_taxas),
                        mes_atual: parseFloat(revendedor.mes_atual),
                        mes_atual_taxas: parseFloat(revendedor.mes_atual_taxas),
                        comissoes: revendedor.comissoes,
                        valor_anterior: `R$ ${accounting.formatNumber(revendedor.mes_anterior, 2, ".", ",")}`,
                        valor_atual: `R$ ${accounting.formatNumber(revendedor.mes_atual, 2, ".", ",")}`,
                        loading:false,
                        refresh:false,
                        show_refresh:false,
                        download:false,
                        show_download:false,
                        close:false,
                    }));
                } catch (ex) {
                    console.warn(ex)
                }
            },
            /**
             * Faz a consulta dos revendedores do sistema, traz resultados individuais
             */
            async getComissoes() {
                this.$Spin.show()
                try {
                    const URI = `comissoes/all/porVendedor`
                    const {data} = await revendaApi.get(URI,{params: {page:this.pagination.page,type:1,search:this.search}})
                    let dados = []
                    if(data!=0){
                        dados = data.data.map(revendedor => ({
                            nome: revendedor.nome,
                            mes_anterior: parseFloat(revendedor.mes_anterior),
                            mes_anterior_taxas: parseFloat(revendedor.mes_anterior_taxas),
                            mes_atual: parseFloat(revendedor.mes_atual),
                            mes_atual_taxas: parseFloat(revendedor.mes_atual_taxas),
                            comissoes: revendedor.comissoes,
                            valor_anterior: `R$ ${accounting.formatNumber(revendedor.mes_anterior, 2, ".", ",")}`,
                            valor_atual: `R$ ${accounting.formatNumber(revendedor.mes_atual, 2, ".", ",")}`,
                            loading:false,
                            refresh:false,
                            show_refresh:false,
                            download:false,
                            show_download:false,
                            close:false,
                        }));
                        if (this.pagination.page === 1) {
                            this.dados = dados;
                        } else {
                            this.dados = this.dados.concat(dados);
                        }
                        if(data.lastPage == this.pagination.page){
                            this.pagination.end_page = true
                        }
                    } else {
                        this.dados = dados
                    }
                } catch (ex) {
                    console.warn(ex)
                }
                this.$Spin.hide()
            },
            ordenar(column,order){
                // a variavel index recebe o valor da coluna que o usuario clicou para mudar o indice de ordenação
                this.key= column
                // muda variavel orientation para fazer a nova orientação conforme a coluna informada pelo usuario.
                this.columns[column].order = order
                this.columns.map((item) => {
                    item.on = false
                    return item
                })
                this.columns[column].on = true
            },
            /**
             * Responsável pela paginação dos tickets quando alcança o fim da página
             */
            handleScroll: _.debounce(function (e) {
                const el = e.target.documentElement || e.target;
                let windowRelativeBottom = el.scrollHeight - el.offsetHeight;
                if ((el.scrollTop > windowRelativeBottom - 50) && (!this.pagination.end_page)) {
                    this.pagination.page++
                    this.getComissoes()
                }
            }, 1000),
        },
        created() {
            this.getComissoesGeral()
            this.getComissoes()
        },
        mounted() {
         window.addEventListener('scroll', this.handleScroll);
           let el = document.querySelector('.content-wrapper');
           if (el) {
               el.addEventListener('scroll', this.handleScroll);
           }
        },
        destroyed() {
           window.removeEventListener('scroll', this.handleScroll);
           let el = document.querySelector('.content-wrapper');
           if (el) {
               el.removeEventListener('scroll', this.handleScroll);
           }
        },
        watch:{
            search:_.debounce(function (e){
                this.pagination.page = 1
                this.getComissoes()
            },500),
        }
    };
</script>
<style lang="scss" scoped>
    #nome {
        .vs-table-text {
            padding-left: 35px;
        }
    }
    @media only screen and (max-width: 2560px) {
        #nome{
            width: 75%;
        }
        #mes_anterior {
            width: 11%;
        }
        #mes_atual {
            width: 14%;
        }
    }
    @media only screen and (max-width: 1920px) {
        #nome{
            width: 73%;
        }
        #mes_anterior {
            width: 10%;
        }
        #mes_atual {
            width: 17%;
        }
    }
    @media only screen and (max-width: 1680px) {
        #nome{
            width: 72%;
        }
        #mes_anterior {
            width: 10%;
        }
        #mes_atual {
            width: 18%;
        }
    }
    @media only screen and (max-width: 1600px) {
        #nome{
            width: 71%;
        }
        #mes_anterior {
            width: 10%;
        }
        #mes_atual {
            width: 19%;
        }
    }
    @media only screen and (max-width: 1440px) {
        #nome{
            width: 71%;
        }
        #mes_anterior {
            width: 12%;
        }
        #mes_atual {
            width: 17%;
        }
    }
    @media only screen and (max-width: 1366px) {
        #nome{
            width: 72%;
        }
        #mes_anterior {
            width: 10%;
        }
        #mes_atual {
            width: 18%;
        }
    }
    @media only screen and (max-width: 1280px) {
        #nome{
            width: 71%;
        }
        #mes_anterior {
            width: 11%;
        }
        #mes_atual {
            width: 18%;
        }
    }
    @media only screen and (max-width: 1024px) {
        #nome{
            width: 68%;
        }
        #mes_anterior {
            width: 14%;
        }
        #mes_atual {
            width: 18%;
        }
    }
    @media only screen and (max-width: 900px) {
        #nome{
            width: 56%;
        }
        #mes_anterior {
            width: 20%;
        }
        #mes_atual {
            width: 24%;
        }
    }
    @media only screen and (max-width: 500px) {
        #nome{
            width: 40%;
        }
        #mes_anterior {
            width: 30%;
        }
        #mes_atual {
            width: 30%;
        }
    }
</style>
